import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "cont_calendar" };
const _hoisted_2 = { class: "c_body" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["disabled"];
const _hoisted_5 = { key: 0 };
const _hoisted_6 = ["title", "onClick"];
const _hoisted_7 = ["onClick", "innerHTML"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["onClick", "title"];
const _hoisted_10 = ["onClick"];
import { reactive, ref, computed, watch } from 'vue';
import { getDayOfWeekByDate } from '@/user/helpers/calendar.helper';
import moment from 'moment';
import { SpriteIcons } from '@/user/components/common';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Calendar',
    props: {
        schedules: {
            type: Object,
            required: false,
        },
        year: {
            type: Number,
            required: true,
        },
        month: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            required: false,
            default: 'lecture',
        },
        selectedDay: {
            type: Number,
            required: false,
            default: null,
        },
    },
    emits: ["itemClick", "dateClick", "prevMonth", "nextMonth"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const currentDay = ref(moment().date());
        const scheduleDetailLayer = reactive({});
        const calculateMonth = (date) => getDayOfWeekByDate(date);
        const currentMonthOfCalendar = reactive({
            calendar: calculateMonth(),
        });
        watch(() => [props.year, props.month], ([newYear, newMonth]) => {
            if (newYear && newMonth) {
                const m = moment([newYear, newMonth - 1, 1]);
                currentMonthOfCalendar.calendar = calculateMonth(m.format('YYYY-MM'));
            }
        }, { immediate: true });
        const flatCalendar = computed(() => currentMonthOfCalendar.calendar.flat(1));
        function handleItemClick(item) {
            emit('itemClick', item);
        }
        function handleDayClick(day) {
            if (day.disabled)
                return;
            if (props.type !== 'exam')
                return;
            const exams = props.schedules?.[day.day] || [];
            if (exams.length === 0)
                return;
            emit('dateClick', day.day, exams);
        }
        function isToday(day) {
            const isTodayNumber = day.day === currentDay.value;
            const isCurrentMonth = props.month === moment().month() + 1;
            const isCurrentYear = props.year === moment().year();
            return !day.disabled && isTodayNumber && isCurrentMonth && isCurrentYear;
        }
        function onTogglePopup(day) {
            scheduleDetailLayer[day] = !scheduleDetailLayer[day];
        }
        function onScheduleClose(day) {
            scheduleDetailLayer[day] = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"week\" data-v-08da8497>Sun</div><div class=\"week\" data-v-08da8497>Mon</div><div class=\"week\" data-v-08da8497>Tue</div><div class=\"week\" data-v-08da8497>Wed</div><div class=\"week\" data-v-08da8497>Thu</div><div class=\"week\" data-v-08da8497>Fri</div><div class=\"week\" data-v-08da8497>Sat</div>", 7)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flatCalendar.value, (day, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["day", { selected: !day.disabled && props.selectedDay === day.day }]),
                            key: index,
                            onClick: ($event) => (handleDayClick(day))
                        }, [
                            _createElementVNode("button", {
                                class: _normalizeClass({ disabled: day.disabled, today: isToday(day), mCursor: !day.disabled }),
                                disabled: day.disabled
                            }, _toDisplayString(day.day), 11, _hoisted_4),
                            (!day.disabled)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((props.schedules[day.day] || []).slice(0, 3), (schedule, idx) => {
                                        return (_openBlock(), _createElementBlock("b", {
                                            key: idx,
                                            title: schedule.title,
                                            class: _normalizeClass(["mCursor", `link_detail link_detail_${day.day} ${schedule.levelColor} ${schedule.canApply ? '' : 'inactive'}`]),
                                            onClick: () => handleItemClick(schedule)
                                        }, _toDisplayString(schedule.title), 11, _hoisted_6));
                                    }), 128)),
                                    ((props.schedules[day.day]?.length || 0) > 3)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            onClick: () => onTogglePopup(day.day),
                                            type: "button",
                                            class: _normalizeClass(["btn_more", { active: scheduleDetailLayer[day.day] }]),
                                            innerHTML: `+${props.schedules[day.day].length - 3}`
                                        }, null, 10, _hoisted_7))
                                        : _createCommentVNode("", true),
                                    ((props.schedules[day.day]?.length || 0) > 3)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: _normalizeClass(["ly_popup", { on: scheduleDetailLayer[day.day] }])
                                        }, [
                                            _createElementVNode("span", {
                                                class: "date",
                                                innerHTML: `${props.year}.${props.month}.${day.day}`
                                            }, null, 8, _hoisted_8),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.schedules[day.day], (schedule, idx) => {
                                                return (_openBlock(), _createElementBlock("button", {
                                                    class: _normalizeClass(["link_detail mCursor", `${schedule.levelColor} ${schedule.canApply ? '' : 'inactive'}`]),
                                                    key: idx,
                                                    onClick: () => handleItemClick(schedule),
                                                    title: schedule.title
                                                }, _toDisplayString(schedule.title), 11, _hoisted_9));
                                            }), 128)),
                                            _createElementVNode("button", {
                                                onClick: () => onScheduleClose(day.day),
                                                class: "img link_close"
                                            }, [
                                                _createVNode(_unref(SpriteIcons), {
                                                    name: "close",
                                                    class: "size-16"
                                                })
                                            ], 8, _hoisted_10)
                                        ], 2))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ], 10, _hoisted_3));
                    }), 128))
                ])
            ]));
        };
    }
});
